import { MONITOR_UPDATE } from '../constants/ActionTypes';

export default function monitors(
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) {
  switch (action.type) {
    case MONITOR_UPDATE:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data,
      };
    default:
      return state;
  }
}
